import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'app-modal-not-permission',
  templateUrl: './modal-not-permission.component.html',
  styleUrl: './modal-not-permission.component.scss',
})
export class ModalNotPermissionComponent {
  @Input() visible: boolean = false;
  @Input() id: any | null = null;
  @Input() buttonAction: (() => void) | null = null;
  @Output() visibleChange = new EventEmitter<boolean>();

  closeDialog() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  onButtonCancelClick() {
    this.closeDialog();
  }
}
